import { useCallback, useEffect, useState } from "react";
import useCommonMap from "./useCommonMap";
import api from "../api";
import { useMap } from "@vis.gl/react-google-maps";

const useFloorplans = ({ commonMapRef = null } = {}) => {
  const [selectedFloorplan, setSelectedFloorplan] = useState(null);
  const [floorplanImage, setFloorplanImage] = useState(null);
  // const map = useMap();
  const commonMap = useCommonMap();

  useEffect(() => {
    if (!commonMap?.map) return;

    if (selectedFloorplan) {
      getFloorplanImage(selectedFloorplan.id);
    } else {
      setFloorplanImage(null);
    }

    return () => {
      setFloorplanImage(null);
      commonMap.map.setHeading(0);
      // commonMap.map.setTilt(0);
      commonMap.map.setZoom(20);
      // commonMap.map.panTo(commonMap.center);
    };
  }, [selectedFloorplan, commonMap.map]);

  const getFloorplanImage = (id) => {
    api
      .get(`files/floorplans/${id}`, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        let blob = new Blob([res.data], { type: "img/jpeg" });
        let url = (window.URL || window.webkitURL).createObjectURL(blob);
        setFloorplanImage(url);
      })
      .catch(() => setFloorplanImage(null));
  };

  const handleFloorplanChanged = useCallback(
    (floorplan) => {
      setSelectedFloorplan(floorplan);
      if (!commonMapRef || !commonMapRef.current) return;
      commonMapRef.current.setSelectedFloorplan(floorplan);
    },
    [setSelectedFloorplan, commonMapRef]
  );

  return { selectedFloorplan, floorplanImage, handleFloorplanChanged };
};

export default useFloorplans;
